export default __webpack_public_path__ + "static/media/walletconnect.2b2109af.svg";